import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import { getAllBankApi } from "../../../Api/Bank";
import { getTypeApi } from "../../../Api/taxonomy";
import { getUserApi } from "../../../Api/user";
import { fetchPurposeApi } from "../../../Api/PurposeType";
import { fetchDonationTypeApi } from "../../../Api/DonationTypes";
import {
  donateApi,
  donationUpdateApi,
  getDonationByIdApi,
} from "../../../Api/Donation";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { getDonationTPApi } from "../../../Api/DonationTypePurpose";
import { getBankStatementApi } from "../../../Api/BankStatement";
import { getAllFeeApi, getAllFeeByUserIdApi, getFeeRenewalsApi } from "../../../Api/Fee";
import { getFeeRequestApi } from "../../../Api/Registration";
import SideModal from "../../general/Sidemodal";
import { UserForm } from "../../../common/components/UserForm";

type Donation = {
  id: string | null;
  typeId: string;
  type: string;
  amount: number;
  purposeId: string;
  purpose: string;
  onBehalfof: string;
  onBehalfofName: string;
  FeeId: string | null;
  fee: Fee
};
type Fees = {
  id: string;
  amount: number;
  courseOfferingId: string;
  userId: string;
  userName: string;
  course: string;
  courseType: string;
  durationType: string;
  type: string;
  feeFor: string;
};
interface Fee {
  amount: number;
  studentId: string;
  typeId: string;
  courseOfferingId: string;
  payingTill?: string;
}
interface Option {
  id: string;
  value: string;
  label: string;
}
interface Options {
  id: string;
  name: string;
}
type DonationBox = {
  type: string;
  id: string;
  value: string;
  parentId: string;
  label: string;
};
interface DonationDetailFormProps {
  url?: string;
  setAdd?: React.Dispatch<React.SetStateAction<boolean>>;
  Id?: string | null;
  onSuccess?: () => void;
  statementId?: string;
  matchingDonationPurpose?: Record<string, any>;
  selectedDonationType?: Record<string, any>;
  fetchAssignedDonationData?: (id: string) => Promise<void>;
}
interface DonationTypePurposeInterface {
  id: string;
  donationTypeId: string;
  donationPurposeId: string;
  purposeid: string;
  label: string;
}

export const DonationDetailForm = ({
  url,
  setAdd,
  Id,
  onSuccess,
  statementId,
  matchingDonationPurpose,
  selectedDonationType,
  fetchAssignedDonationData,
}: DonationDetailFormProps) => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");
  const location = useLocation();
  const { id: locationId } = (location.state as { id?: string }) || {};
  const id = Id || locationId;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [ReuserDropdown, setReuserDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleDrawerOpen = () => setIsOpen(true);
  const handleDrawerClose = () => setIsOpen(false);
  const accountType = useMemo(
    () => [
      { id: 1, value: "Ezpay" },
      { id: 2, value: "Bank" },
      { id: 3, value: "Cash" },
      { id: 4, value: "Box" },
    ],
    []
  );
  const [donationAmount, setDonationAmount] = useState<number>(0);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [datevalue, setDateValue] = useState<string | null>(null);
  const [referenceNo, setReferenceNo] = useState<string>("");
  const [isEditModal, setIsEditModal] = useState<boolean>(false);
  const [isEditDetails, setIsEditDetails] = useState(false);
  const [donations, setDonations] = useState<Donation[]>([]);
  const [onBehalfof, setOnBehalfof] = useState<string>("Self");
  const [onBehalfofName, setOnBehalfofName] = useState<string>("");
  const [totalDonationAmount, setTotalDonaionAmount] = useState<number>();
  const [donationTypeOptions, setDonationTypeOptions] = useState<Options[]>([]);
  const [purposeOptions, setPurposeOptions] = useState<Options[]>([]);
  const [donationPurpose, setDonationPurpose] = useState<Option | null>(
    null
  ) as any;
  const [donationType, setDonationType] = useState<Option | null>(null) as any;
  const [donationTP, setDonationTP] = useState<DonationTypePurposeInterface[]>(
    []
  );
  const [box, setBox] = useState<DonationBox[]>([]);
  const [loading, setLoading] = useState(true);
  const [feeDetails, setFeeDetails] = useState<Fees[]>([]);
  const [selectedFeeData, setSelectedFeeData] = useState<any>();
  const [searchPaidUserName, setSearchPaidUserName] = useState<string>("");
  const [searchPaidUserResults, setSearchPaidUserResults] = useState<any[]>([]);
  const [selectedPaidUserId, setSelectedPaidUserId] = useState<string | null>(null);
  const [isPaidDropdownOpen, setIsPaidDropdownOpen] = useState(false);
  const [payCount, setPayCount] = useState<number>(1);
  const [payingFrom, setPayingFrom] = useState<string>("");
  const [payingTill, setPayingTill] = useState<string>("");
  const [banks, setBanks] = useState([]);
  const [searchUserName, setSearchUserName] = useState<string>("");
  const [searchUserResults, setSearchUserResults] = useState<any[]>([]);
  const [selectedBankId, setSelectedBankId] = useState<string | null>(null);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [selectedAccountType, setSelectedAccountType] = useState<string>("");
  const [selectedbox, setSelectedBox] = useState<string | null>(null);
  const [receivedUserName, setreceivedUserName] = useState<string>("");
  const [receviedUserId, setreceivedUserId] = useState<string | null>(null);
  const [bankStatementId, setbankStatementId] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchBanks = useCallback(async () => {
    try {
      const response = await getAllBankApi(url);
      const formattedBanks = response.map((bank: any) => ({
        id: bank.id,
        value: bank.id,
        label: `${bank.name} - ${bank.accountNumber}`,
        donationPurposeId: bank.donationPurposeId,
      }));
      setBanks(formattedBanks);
    } catch (error) {
      toast.error("Error fetching bank data:");
    }
  }, [url]);

  useEffect(() => {
    fetchBanks();
  }, [fetchBanks]);

  useEffect(() => {
    async function fetchDonationTypePurpose() {
      try {
        const fetchDonation = await getDonationTPApi("donationTPId", url);
        setDonationTP(fetchDonation);
      } catch (error) {
        toast.error("Failed to fetch Donation Type Purpose data.");
      }
    }
    fetchDonationTypePurpose();
  }, [url]);

  useEffect(() => {
    if (!searchPaidUserName.trim()) {
      setSearchPaidUserResults([]);
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      fetchPaidUserData(searchPaidUserName);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchPaidUserName]);

  useEffect(() => {
    const handleGetApi = async () => {
      if (id) {
        try {
          const response = await getDonationByIdApi(id, url);
          if (response.transactionType === 2) {
            setSelectedBankId(response?.bankTransaction?.bankId || null);
            setReferenceNo(response?.bankTransaction?.referenceNumber || "");
            const transactionDate = response.donatedOn;
            setDateValue(transactionDate);
          } else {
            if (response.transactionType === 3) {
              setSelectedBankId(null);
              setReferenceNo("");
              const transactionDate = response.donatedOn;
              setreceivedUserId(response?.cashTransaction?.receivedBy || null);
              setreceivedUserName(
                response?.cashTransaction?.receivedName || null
              );
              setDateValue(transactionDate);
            } else {
              setSelectedBankId(null);
              setReferenceNo("");
              const transactionDate = response.donatedOn;
              setDateValue(transactionDate);
            }
            if (response.transactionType === 4) {
              setSelectedBox(response?.boxTransaction?.boxId || null);
              setreceivedUserId(response?.boxTransaction?.receivedBy || null);
              setreceivedUserName(
                response?.boxTransaction?.receivedName || null
              );
            }
          }
          const selectAccountType =
            accountType.find((type) => response.transactionType === type.id)
              ?.value || "Other";
          setSelectedAccountType(selectAccountType);
          setSelectedUserId(response.userId);
          setSearchUserName(response.userName);
          setTotalDonaionAmount(response.amount);

          const donations = response?.donationDetails.map((details: any) => ({
            id: details.id,
            typeId: details.donationTypeId,
            type: details.donationType,
            amount: details.amount,
            purposeId: details.donationPurposeId,
            purpose: details.donationPurpose,
            onBehalfof: details.onBehalfOf ? "Others" : "Self",
            onBehalfofName: details.onBehalfOf
              ? details.onBehalfOf
              : "--------",
          }));
          setLoading(false);
          setIsEditDetails(true);
          setDonations(donations);
        } catch (error) {
          toast.error("Error fetching donation details: ");
        }
      }
    };
    handleGetApi();
  }, [id, accountType, url]);

  useEffect(() => {
    if (id) {
      setIsEditDetails(true);
      setLoading(true);
    } else {
      setIsEditDetails(false);
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (!searchUserName.trim()) {
      setSearchUserResults([]);
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      fetchUserData(searchUserName);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchUserName]);

  useEffect(() => {
    if (!receivedUserName.trim()) {
      setSearchUserResults([]);
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      fetchUserData(receivedUserName);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [receivedUserName]);

  useEffect(() => {
    if (!url) return;
    
    const fetchAllTaxonomies = async () => {
      try {
        const [typeResponse, purposeResponse] = await Promise.all([
          fetchDonationTypeApi(url),
          fetchPurposeApi(url),
        ]);
        setDonationTypeOptions(typeResponse);
        setPurposeOptions(purposeResponse as Options[]);
      } catch (error) {
        toast.error("Failed to load donation types and purposes");
        console.error("Error loading taxonomies:", error);
      }
    };
    fetchAllTaxonomies();
  }, [url]);

  // Only fetch Box taxonomy when Box account type is selected
  useEffect(() => {
    if (!url || selectedAccountType !== "Box") return;
    
    const fetchBoxTaxonomy = async () => {
      try {
        const boxsequence = await getTypeApi("Box", url);
        setBox(boxsequence);
      } catch (error) {
        toast.error("Failed to load box list");
        console.error("Error loading box taxonomy:", error);
      }
    };
    fetchBoxTaxonomy();
  }, [url, selectedAccountType]);

  useEffect(() => {
    if (!statementId) return;
    const fetchBankstatementById = async () => {
      try {
        const response = await getBankStatementApi(url, statementId);
        response.forEach((item: any) => {
          setSelectedAccountType("Bank");
          const matchedBank = banks.find((bank) => bank.id === item.bankId);
          if (matchedBank) {
            setSelectedBankId(matchedBank.id);
          }
          setReferenceNo(item.description);
          setDateValue(item.valueDate);
          setbankStatementId(statementId);
          const donations = response.map((item: any) => ({
            purposeId: matchingDonationPurpose.id,
            purpose: matchingDonationPurpose.name,
            typeId: selectedDonationType.id,
            type: selectedDonationType.name,
            amount: item.transactionAmount,
          }));
          setDonations(donations);
        });
      } catch (error) {
        console.error("Error fetching Data:", error);
      }
    };
    fetchBankstatementById();
  }, [statementId, banks, url, matchingDonationPurpose, selectedDonationType]);


  useEffect(() => {
    if (selectedFeeData) {
      const fromDate = selectedFeeData.paidTill || new Date().toISOString().slice(0, 10);
      setPayingFrom(fromDate);

      // Default paying till: 1 month/year after fromDate
      const from = new Date(fromDate);
      if (!isNaN(from.getTime())) {
        if (selectedFeeData.durationType === "Monthly") {
          from.setMonth(from.getMonth() + 1);
        } else if (selectedFeeData.durationType === "Yearly") {
          from.setFullYear(from.getFullYear() + 1);
        }
        setPayingTill(from.toISOString().slice(0, 10));
      }
    }
  }, [selectedFeeData]);

  useEffect(() => {
    if (selectedFeeData && payingFrom && payingTill) {
      const amt = getProRataAmount(payingFrom, payingTill, selectedFeeData.durationType, selectedFeeData.amount);
      setDonationAmount(amt);
    }
  }, [payingFrom, payingTill, selectedFeeData]);


  const fetchAllFee = async () => {
    try {
      const FeeResponce = await getAllFeeByUserIdApi(url, selectedPaidUserId) as Fees[];
      setFeeDetails(FeeResponce);
    } catch (error) {
      toast.error("Error fetching fee data");
    }
  };

  const handlePaidUserSelection = (value: string) => {
    const selectedUser = searchPaidUserResults.find((user) => user.id === value);
    if (selectedUser) {
      setSearchPaidUserName(selectedUser.name);
      setSelectedPaidUserId(selectedUser.id);
      setIsPaidDropdownOpen(false);
      fetchAllFee();
    } else {
      toast.error("No user found for the selected value");
    }
  };

  const fetchPaidUserData = async (searchTerm: string) => {
    try {
      const response = await getUserApi(searchTerm, url);
      console.log("Paid User Data", response);
      setSearchPaidUserResults(response);
    } catch (error) {
      toast.error("Not Able To Fetch user name");
    }
  };

  function handleResetForm() {
    setDonationType(null);
    setDonationAmount(0);
    setDonationPurpose(null);
    setOnBehalfof("");
    setOnBehalfofName("");
  }

  function handleSubmitClick(e: React.FormEvent) {
    e.preventDefault();
    if (!donationAmount || donationAmount <= 0) {
      toast.error("Please fill all the fields");
      return;
    }
    if (onBehalfof === "Others" && !onBehalfofName) {
      toast.error("Please enter name for Others");
      return;
    }

    const feeData = selectedFeeData ? {
      amount: donationAmount,
      studentId: selectedFeeData.userId,
      typeId: selectedFeeData.id,
      courseOfferingId: selectedFeeData.courseOfferingId,
      payingTill: payingTill || selectedFeeData.paidTill,
    } : null;


    const donationData = {
      id: editingIndex !== null ? donations[editingIndex].id : null,
      typeId: donationType?.id,
      type: donationType?.value,
      purposeId: donationPurpose?.id,
      purpose: donationPurpose?.value,
      amount: donationAmount,
      onBehalfof: onBehalfof,
      onBehalfofName: onBehalfof === "Others" ? onBehalfofName : "",
      FeeId: selectedFeeData?.id || null,
      fee: feeData
    };


    if (editingIndex !== null) {
      const updatedDonations = [...donations];
      updatedDonations[editingIndex] = donationData;
      setDonations(updatedDonations);
      setEditingIndex(null);
      setIsEditModal(false);
    } else {
      setDonations([...donations, donationData]);
    }
    handleResetForm();
    handleDrawerClose();
  }

  const handleEditClick = (index: number, id: string) => {
    const donation = donations[index];
    setDonationType({
      value: donation.type,
      id: donation.typeId,
      label: donation.type,
    });
    setDonationAmount(donation.amount);
    const selectFee = feeDetails.find((fee) => fee.id === donation.FeeId);
    setSelectedFeeData(selectFee);

    setDonationPurpose({
      value: donation.purpose,
      id: donation.purposeId,
      label: donation.purpose,
    });
    setOnBehalfof(donation.onBehalfof);
    setOnBehalfofName(donation.onBehalfofName);
    setEditingIndex(index);
    setIsEditModal(true);
    setIsOpen(true);
  };

  const handleDonationButton = async (action) => {
    if (selectedAccountType === "Bank") {
      if (!selectedBankId || !datevalue || !referenceNo) {
        toast.error("Please fill all the required fields");
        return;
      }
    } else if (selectedAccountType === "Cash") {
      if (!selectedUserId || !datevalue) {
        toast.error("Please fill all the fields");
        return;
      }
    }

    const transactionType =
      accountType.find(
        (accType) =>
          selectedAccountType.trim().toLowerCase() ===
          accType.value.trim().toLowerCase()
      )?.id || 0;

    if (isEditDetails === true) {
      const details = donations.map((donation) => ({
        id: donation.id && isValidGuid(donation.id) ? donation.id : undefined,
        amount: donation.amount,
        donationTypeId: donation.typeId,
        donationPurposeId: donation.purposeId,
        onBehalfOf: donation?.onBehalfofName,
        OnBehalfofName: donation?.onBehalfofName,
      }));
      if (
        selectedAccountType === "EzPay" &&
        totalAmount !== totalDonationAmount
      ) {
        toast.error(
          `Total donation amount cannot be changed for EzPay. It must equal to ${totalDonationAmount}.`
        );
        return;
      }
      try {
        await donationUpdateApi(
          url,
          id,
          totalAmount,
          details,
          transactionType,
          selectedUserId || null,
          selectedBankId,
          datevalue,
          referenceNo,
          selectedbox,
          receviedUserId
        );
        if (onSuccess) onSuccess();
        toast.success("Details Updated Successfully");
        if (action === "close") {
          setSelectedAccountType("");
          setSearchUserName("");
          setreceivedUserName("");
          setSelectedUserId(null);
          setreceivedUserId("");
          setSelectedBankId("");
          setSelectedBox("");
          setDateValue("");
          setReferenceNo("");
          setDonations([]);
          setAdd(false);
        } else if (action === "new") {
          setSelectedAccountType("");
          setSearchUserName("");
          setreceivedUserName("");
          setSelectedUserId(null);
          setreceivedUserId(null);
          setSelectedBankId("");
          setSelectedBox(null);
          setDateValue("");
          setReferenceNo("");
          setDonations([]);
          setAdd(false);
        }
      } catch (error) {
        toast.error("Failed to Update Details");
      }
    } else {


      const details = donations.map((donation, index) => {

        const { fee } = donation;
        const hasValidFee =
          fee &&
          (fee.amount !== undefined ||
            fee.typeId !== undefined ||
            fee.studentId !== undefined ||
            fee.courseOfferingId !== undefined ||
            fee.payingTill !== undefined);

        const detail = {
          amount: donation.amount,
          donationTypeId: donation.typeId,
          donationPurposeId: donation.purposeId,
          onBehalfOf: donation.onBehalfofName,
          fee: hasValidFee ? fee : null,
        };
        return detail;
      });


      try {
        await donateApi(
          totalAmount,
          details,
          token,
          transactionType,
          selectedUserId || null,
          selectedBankId,
          datevalue,
          referenceNo,
          selectedbox,
          receviedUserId,
          bankStatementId ? bankStatementId : null
        );
        if (onSuccess) onSuccess();
        toast.success("Entry Added Successfully");
        if (action === "close") {
          setSelectedAccountType("");
          setSearchUserName("");
          setreceivedUserName("");
          setSelectedUserId(null);
          setreceivedUserId("");
          setSelectedBankId("");
          setSelectedBox("");
          setDateValue("");
          setReferenceNo("");
          setDonations([]);
          setAdd(false);
        } else if (action === "new") {
          setSelectedAccountType("");
          setSearchUserName("");
          setreceivedUserName("");
          setSelectedUserId(null);
          setreceivedUserId(null);
          setSelectedBankId(null);
          setSelectedBox(null);
          setDateValue("");
          setReferenceNo("");
          setDonations([]);
          setAdd(false);
        }
      } catch (error) {
        toast.error("Failed to Add Entry");
      }
    }
    // if (statementId) {
    //   await fetchAssignedDonationData(statementId);
    // }
  };

  function isValidGuid(value: string) {
    const guidPattern =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
    return guidPattern.test(value);
  }

  const fetchUserData = async (searchTerm: string) => {
    try {
      const response = await getUserApi(searchTerm, url);
      setSearchUserResults(response);
    } catch (error) {
      toast.error("Not Able To Fetch user name");
    }
  };

  const handleUserSelection = (value: string) => {
    const selectedUser = searchUserResults.find((user) => user.name === value);
    if (selectedUser) {
      setSearchUserName(selectedUser.name);
      setSelectedUserId(selectedUser.id);
      setIsDropdownOpen(false);
    } else {
      toast.error("No user found for the selected value");
    }
  };

  const handleReceivedUserSelection = (value: string) => {
    const selectedReceviedUser = searchUserResults.find(
      (user) => user.name === value
    );
    if (selectedReceviedUser) {
      setreceivedUserName(selectedReceviedUser.name);
      setreceivedUserId(selectedReceviedUser.id);
      setReuserDropdown(false);
    } else {
      toast.error("No user found for the selected value");
    }
  };

  const handleSelectFee = (value: string): void => {
    if (value === "") {
      setSelectedFeeData(undefined);
      setDonationAmount(0);
      setOnBehalfof("");
      setOnBehalfofName("");
      return;
    }

    let fee = feeDetails.find((fee) => fee.id === value);

    // If found in feeDetails
    if (fee) {
      setSelectedFeeData(fee);
      setDonationAmount(fee.amount);
      setOnBehalfof(fee.feeFor);
      setOnBehalfofName(fee.userName);
    }
  };

  const allDonationOptions = donationTypeOptions
    .filter((res) => donationTP.some((tp) => tp.donationTypeId === res.id))
    .map((DonationType) => ({
      value: DonationType.name,
      id: DonationType.id,
      label: DonationType.name,
    }));

  const donationOptions = useMemo(() => {
    if (donationPurpose?.id) {
      const allowedTypeIds = donationTP
        .filter((tp) => tp.donationPurposeId === donationPurpose.id)
        .map((tp) => tp.donationTypeId);
      return allDonationOptions.filter((opt) => allowedTypeIds.includes(opt.id));
    }
    return allDonationOptions;
  }, [allDonationOptions, donationPurpose, donationTP]);

  const donationPurposeOptions = purposeOptions.map((DonationPurpose) => ({
    value: DonationPurpose.name,
    id: DonationPurpose.id,
    label: DonationPurpose.name,
  }));

  const totalAmount = donations.reduce(
    (sum, donation) => sum + Number(donation.amount || 0),
    0
  );

  const boxsequence = box.filter(
    (item) => item.type === "Box" && item.parentId == null
  );

  const matchedFeeDetails = feeDetails.filter((feeDetail) =>
    donations.some((donation) => donation.FeeId === feeDetail.id)
  );

  function getProRataAmount(from: string, till: string, type: string, amount: number) {
    const d1 = new Date(from);
    const d2 = new Date(till);
    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return 0;

    if (type === "Monthly") {
      let months = (d2.getFullYear() - d1.getFullYear()) * 12 + (d2.getMonth() - d1.getMonth());
      const anchor = new Date(d1);
      anchor.setMonth(anchor.getMonth() + months);
      let total = months * amount;
      if (d2 > anchor) {
        const extraDays = (d2.getTime() - anchor.getTime()) / (1000 * 60 * 60 * 24);
        total += Math.round((amount / 30) * extraDays);
      }
      return total;
    } else if (type === "Yearly") {
      let years = d2.getFullYear() - d1.getFullYear();
      const anchor = new Date(d1);
      anchor.setFullYear(anchor.getFullYear() + years);
      let total = years * amount;
      if (d2 > anchor) {
        const extraDays = (d2.getTime() - anchor.getTime()) / (1000 * 60 * 60 * 24);
        total += Math.round((amount / 365) * extraDays);
      }
      return total;
    }
    return amount;
  }

  const handleNavigation = (event: React.MouseEvent, _url: string) => {
    event.preventDefault();
    setIsModalOpen(true);
  };

  const handleUserSaved = () => {
    if (searchUserName.trim()) {
      fetchUserData(searchUserName);
    }
    if (searchPaidUserName.trim()) {
      fetchPaidUserData(searchPaidUserName);
    }
  };

  return (
    <div className="px-4">
      {/* <div className=""> */}
      <div className="space-y-3">
        {loading ? (
          <div className="flex justify-center items-center h-screen">
            <div
              className="flex justify-center items-center h-12 w-12 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] text-blue-600"
              role="status"
            >
              <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                Loading...
              </span>
            </div>
          </div>
        ) : (
          <div className="mt-4 space-y-3">
            <h2 className="text-3xl font-bold text-blue-600 mb-9 mt-5 justify-center sticky top-0 bg-white z-10 py-2">
              {isEditDetails ? "Edit Detail" : "Add New Detail"}
            </h2>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Transaction By
              </label>
              <select
                required
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={selectedAccountType}
                onChange={(e) => setSelectedAccountType(e.target.value)}
                disabled={isEditDetails}
              >
                <option value="" disabled>
                  Select Transaction By
                </option>
                {(isEditDetails
                  ? ["EzPay", "Bank", "Cash", "Box"]
                  : ["Bank", "Cash", "Box"]
                ).map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            {selectedAccountType === "Box" && (
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Box
                </label>
                <select
                  required
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm  focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
                  value={selectedbox || ""}
                  onChange={(e) => setSelectedBox(e.target.value)}
                >
                  <option value="" disabled>
                    Choose Box
                  </option>
                  {boxsequence.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.value}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700">
                User Name
              </label>
              <input
                type="text"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Type to search user..."
                value={searchUserName}
                onChange={(e) => {
                  setSearchUserName(e.target.value);
                  setIsDropdownOpen(true);
                }}
              />
              {/* Dropdown list */}
              {isDropdownOpen && (
                <div className="absolute z-10 mt-1 w-full max-h-60 overflow-y-auto bg-white shadow-lg rounded-md border border-gray-300">
                  {searchUserName && searchUserResults.length > 0
                    ? searchUserResults.map((user) => (
                      <div
                        key={user.name}
                        className="py-2 px-3 cursor-pointer hover:bg-blue-500 hover:text-white"
                        onClick={() => handleUserSelection(user.name)}
                      >
                        {user.name},{user.mobile},{user.email}
                      </div>
                    ))
                    : searchUserName && (
                      <div className="flex flex-row justify-between items-center">
                        <div className="py-2 px-3 text-gray-500">
                          No data found
                        </div>
                        <div className="flex justify-start  md:justify-start ">
                          <button
                            type="button"
                            onClick={(event) => handleNavigation(event, "/admin/users/userform")}
                            className=" text-white pl-2 py-2 rounded-md mr-1"
                          >
                            <FaPlus className="font-medium mr-2 text-blue-600 w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    )}
                </div>
              )}
            </div>
            {(selectedAccountType === "Box" ||
              selectedAccountType === "Cash") && (
                <div className="relative">
                  <label className="block text-sm font-medium text-gray-700">
                    Received By
                  </label>
                  <input
                    type="text"
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Type to search user..."
                    value={receivedUserName}
                    onChange={(e) => {
                      setreceivedUserName(e.target.value);
                      setReuserDropdown(true);
                    }}
                  />
                  {ReuserDropdown && (
                    <div className="absolute z-10 mt-1 w-full max-h-60 overflow-y-auto bg-white shadow-lg rounded-md border border-gray-300">
                      {receivedUserName && searchUserResults.length > 0
                        ? searchUserResults.map((user) => (
                          <div
                            key={user.name}
                            className="py-2 px-3 cursor-pointer hover:bg-blue-500 hover:text-white"
                            onClick={() =>
                              handleReceivedUserSelection(user.name)
                            }
                          >
                            {user.name},{user.mobile},{user.email}
                          </div>
                        ))
                        : receivedUserName && (
                          <div className="py-2 px-3 text-gray-500">
                            No data found
                          </div>
                        )}
                    </div>
                  )}
                </div>
              )}
            {selectedAccountType !== "Cash" &&
              selectedAccountType !== "EzPay" &&
              selectedAccountType !== "Box" && (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Bank
                    </label>
                    <select
                      required
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      value={selectedBankId || ""}
                      onChange={(e) => setSelectedBankId(e.target.value)}
                    >
                      <option value="" disabled>
                        Choose Bank - Account number
                      </option>
                      {banks.map((bank: any) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Reference number
                    </label>
                    <input
                      required
                      type="text"
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      value={referenceNo}
                      onChange={(e) => setReferenceNo(e.target.value)}
                      placeholder="Reference number"
                    />
                  </div>
                </>
              )}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Date
              </label>
              <input
                required
                type="date"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={datevalue}
                onChange={(e) => setDateValue(e.target.value)}
                placeholder="YYYY-MM-DD"
              />
            </div>
          </div>
        )}
        {/* Toggle button */}
        <div className="flex space-x-4">
          <button
            onClick={handleDrawerOpen}
            className="mt-4 flex items-center justify-center px-4 py-2 text-sm tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
          >
            <FaPlus className="mr-2 w-4" />
            Details
          </button>
          <button
            onClick={() => setAdd(false)}
            className="mt-4 px-4 py-2 text-sm text-white capitalize bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
          >
            Cancel
          </button>
        </div>

        <SideModal isOpen={isOpen} onClose={handleDrawerClose}>
          <div className="p-2">
            <h2 className="text-center text-3xl font-bold text-blue-600 mb-9 mt-5 justify-center sticky top-0 bg-white z-10 py-2">
              {isEditDetails ? "Updating Details" : "Adding New Details"}
            </h2>
            <form onSubmit={handleSubmitClick} className="space-y-4">


              <div className="flex flex-col w-full">
                <label
                  htmlFor="donation-purpose"
                  className="text-sm font-medium text-gray-700 mb-1"
                >
                  Donation Purpose
                </label>

                {isEditDetails &&
                  donationPurpose?.value === "Online Classes" &&
                  donationType?.value === "Normal / Sadaqah Nafilah" ? (
                  <p className="w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700 px-3 py-2">
                    {donationPurpose?.label}
                  </p>
                ) : (
                  <select
                    id="donation-purpose"
                    className="w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700 px-3 py-2"
                    value={donationPurpose?.value || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const matchdonationpurpose =
                        donationPurpose?.value === "Online Classes";
                      if (matchdonationpurpose) {
                        setSelectedFeeData(undefined);
                        setDonationAmount(0);
                        setOnBehalfof("");
                        setOnBehalfofName("");
                      }

                      if (value === "") {
                        setDonationPurpose(undefined);
                        return;
                      }
                      const taxonomyPurpose = donationPurposeOptions.find(
                        (p) => p.value === value
                      );
                      if (taxonomyPurpose) {
                        const nextPurpose = {
                          value: taxonomyPurpose.value,
                          id: taxonomyPurpose.id,
                          label: taxonomyPurpose.value,
                        } as Option;
                        setDonationPurpose(nextPurpose);


                        const allowedTypeIds = donationTP
                          .filter((tp) => tp.donationPurposeId === taxonomyPurpose.id)
                          .map((tp) => tp.donationTypeId);
                        const filteredTypes = allDonationOptions.filter((opt) =>
                          allowedTypeIds.includes(opt.id)
                        );
                        if (filteredTypes.length === 1) {
                          setDonationType(filteredTypes[0]);
                        }
                      }
                    }}
                  >
                    <option value="">Select Donation Purpose</option>
                    {donationPurposeOptions
                      .filter((p) =>
                        !(isEditDetails && p.value === "Online Classes")
                      )
                      .map((p) => (
                        <option key={p.id} value={p.value}>
                          {p.label}
                        </option>
                      ))}
                    ;
                  </select>
                )}
              </div>
              <div>
                <label
                  htmlFor="donationType"
                  className="block text-sm font-medium text-globalBg mb-1"
                >
                  Donation Type
                </label>
                {isEditDetails &&
                  donationPurpose?.value === "Online Classes" &&
                  donationType?.value === "Normal / Sadaqah Nafilah" ? (
                  <p className="text-gray-800 px-2 py-2 border border-gray-300 rounded-md">
                    {donationType?.label}
                  </p>
                ) : (
                  <select
                    id="donationType"
                    value={donationType?.value || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const matchdonationType =
                        donationType?.value === "Normal / Sadaqah Nafilah";
                      if (matchdonationType && !isEditDetails) {
                        setSelectedFeeData(undefined);
                        setDonationAmount(0);
                        setOnBehalfof("");
                        setOnBehalfofName("");
                      }
                      if (value === "") {
                        setDonationType(undefined);
                        return;
                      }
                      const selectedType = donationOptions.find(
                        (option) => option.value === value
                      );
                      if (selectedType) {
                        setDonationType(selectedType);
                      }
                    }}
                    className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-500"
                  >
                    <option value="">Select Donation Type</option>
                    {donationOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                )}
              </div>


              {donationType?.value === "Fees" &&
                donationPurpose?.value === "Online Classes" && (
                  <>
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700">
                        User Name
                      </label>
                      <input
                        type="text"
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Type to search user..."
                        value={searchPaidUserName}
                        onChange={(e) => {
                          setSearchPaidUserName(e.target.value);
                          setIsPaidDropdownOpen(true);
                        }}
                      />
                      {/* Dropdown list */}
                      {isPaidDropdownOpen && (
                        <div className="absolute z-10 mt-1 w-full max-h-60 overflow-y-auto bg-white shadow-lg rounded-md border border-gray-300">
                          {searchPaidUserName && searchPaidUserResults.length > 0
                            ? searchPaidUserResults.map((user) => (
                              <div
                                key={user.id}
                                className="py-2 px-3 cursor-pointer hover:bg-blue-500 hover:text-white"
                                onClick={() => handlePaidUserSelection(user.id)}
                              >
                                {user.name}
                              </div>
                            ))
                            : searchPaidUserName && (
                              <div className="py-2 px-3 text-gray-500">
                                No data found
                              </div>
                            )}
                        </div>
                      )}
                    </div>
                    <div className="mb-4">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Course
                      </label>
                      <select
                        required
                        className="w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700 px-3 py-2"
                        value={selectedFeeData?.id || ""}
                        onChange={(e) => handleSelectFee(e.target.value)}
                        disabled={isEditDetails}
                      >
                        {isEditDetails ? (
                          <option
                            key={selectedFeeData?.id}
                            value={selectedFeeData?.id}
                          >
                            {selectedFeeData?.courseName} -{" "}
                            {selectedFeeData?.courseType} -{" "}
                            {selectedFeeData?.userName}
                          </option>
                        ) : (
                          <>
                            <option value="">Select Course</option>
                            {feeDetails
                              .filter((fee) => !donations.some((donation) => donation.fee.typeId === fee.id) || fee.id === selectedFeeData?.id)
                              .map((fee) => (
                                <option key={fee.id} value={fee.id}>
                                  {fee.course} - {fee.courseType} -{" "}
                                  {fee.userName} - {fee.type}
                                </option>
                              ))}
                          </>
                        )}
                      </select>
                    </div>

                    {selectedFeeData && selectedFeeData.type === "Renewal" && (
                      <>
                        <div className="gap-4 mt-2">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Paying From
                            </label>
                            <input
                              type="date"
                              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                              value={selectedFeeData.paidTill?.slice(0, 10)}
                              disabled
                            />
                          </div>

                          <div className="mt-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Duration
                            </label>
                            <select
                              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                              value={payCount}
                              onChange={(e) => {
                                const count = parseInt(e.target.value);
                                setPayCount(count);

                                // Update paying till based on new duration
                                const fromDate = new Date(selectedFeeData.paidTill);
                                if (!isNaN(fromDate.getTime())) {
                                  const newTillDate = new Date(fromDate);
                                  if (selectedFeeData.durationType === "Monthly") {
                                    newTillDate.setMonth(newTillDate.getMonth() + count);
                                  } else if (selectedFeeData.durationType === "Yearly") {
                                    newTillDate.setFullYear(newTillDate.getFullYear() + count);
                                  }
                                  setPayingTill(newTillDate.toISOString().slice(0, 10));
                                }
                              }}
                            >
                              {[1, 2, 3, 4, 5, 6].map((num) => (
                                <option key={num} value={num}>
                                  {num}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="mt-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Paying Till
                            </label>
                            <input
                              type="date"
                              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                              value={payingTill}
                              min={
                                (() => {
                                  if (!selectedFeeData.paidTill) return "";
                                  const minDate = new Date(selectedFeeData.paidTill);
                                  if (isNaN(minDate.getTime())) return "";
                                  if (selectedFeeData.durationType === "Monthly") {
                                    minDate.setMonth(minDate.getMonth() + 1);
                                  } else if (selectedFeeData.durationType === "Yearly") {
                                    minDate.setFullYear(minDate.getFullYear() + 1);
                                  }
                                  return minDate.toISOString().slice(0, 10);
                                })()
                              }
                              onChange={(e) => {
                                const newDate = e.target.value;
                                setPayingTill(newDate);

                                // Calculate and update duration based on date difference
                                const fromDate = new Date(selectedFeeData.paidTill);
                                const tillDate = new Date(newDate);

                                if (!isNaN(fromDate.getTime()) && !isNaN(tillDate.getTime())) {
                                  if (selectedFeeData.durationType === "Monthly") {
                                    const months = (tillDate.getFullYear() - fromDate.getFullYear()) * 12
                                      + (tillDate.getMonth() - fromDate.getMonth());
                                    const days = tillDate.getDate() - fromDate.getDate();

                                    // If days are more than 15, round up to next month
                                    const adjustedMonths = days > 15 ? months + 1 : months;
                                    const clampedMonths = Math.min(Math.max(1, adjustedMonths), 6);
                                    setPayCount(clampedMonths);
                                  } else if (selectedFeeData.durationType === "Yearly") {
                                    const years = tillDate.getFullYear() - fromDate.getFullYear();
                                    const monthDiff = tillDate.getMonth() - fromDate.getMonth();
                                    const dayDiff = tillDate.getDate() - fromDate.getDate();

                                    // If more than 6 months or if exactly 6 months and more days, round up
                                    const adjustedYears = (monthDiff > 6 || (monthDiff === 6 && dayDiff > 0))
                                      ? years + 1 : years;
                                    const clampedYears = Math.min(Math.max(1, adjustedYears), 6);
                                    setPayCount(clampedYears);
                                  }
                                }
                              }}
                            />
                          </div>
                        </div>
                      </>
                    )}

                  </>
                )}

              <div>
                <label
                  htmlFor="donationAmount"
                  className="block text-sm font-medium text-globalBg -700 mb-1"
                >
                  Donation Amount
                </label>
                <input
                  disabled={selectedFeeData}
                  id="donationAmount"
                  type="number"
                  value={donationAmount || ""}
                  onChange={(e) => setDonationAmount(Number(e.target.value))}
                  required
                  className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-500"
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="onBehalfOf"
                  className="block text-sm font-medium text-globalBg -700 mb-1"
                >
                  On Behalf of
                </label>
                <select
                  id="onBehalfOf"
                  value={onBehalfof}
                  onChange={(e) => {
                    const value = e.target.value;
                    setOnBehalfof(value);
                    if (value === "Self") {
                      setOnBehalfofName("");
                    } else {
                      setOnBehalfofName(onBehalfofName);
                    }
                  }}
                  className="w-full p-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="Self">Self</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              {onBehalfof === "Others" && (
                <div className="mb-4">
                  <label
                    htmlFor="onBehalfOfName"
                    className="block text-sm font-medium text-globalBg -700 mb-1"
                  >
                    Name
                  </label>
                  <input
                    id="onBehalfOfName"
                    type="text"
                    value={onBehalfofName}
                    onChange={(e) => setOnBehalfofName(e.target.value)}
                    className="w-full p-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-500"
                    required
                  />
                </div>
              )}

              <div className="flex space-x-4 mt-6">
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  {isEditModal ? "Update" : "Add"}
                </button>
                <button
                  type="button"
                  onClick={handleDrawerClose}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </SideModal>



        <div className="mt-6">
          {donations.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="font-normal border border-gray-300 px-4 py-2">
                      Actions
                    </th>
                    <th className="font-normal border border-gray-300 px-4 py-2">
                      Purpose
                    </th>
                    <th className="font-normal border border-gray-300 px-4 py-2">
                      Type
                    </th>
                    {matchedFeeDetails.length > 0 && (
                      <th className="font-normal border border-gray-300 px-4 py-2">
                        Course
                      </th>
                    )}
                    <th className="font-normal border border-gray-300 px-4 py-2">
                      Amount
                    </th>
                    <th className="font-normal border border-gray-300 px-4 py-2">
                      On Behalf of
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {donations.map((donation, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="border border-gray-300 px-4 py-2 ">
                        <div className="flex justify-center space-x-4">
                          <button
                            className="flex item-center space-y-1 text-blue-600 hover:text-blue-800 "
                            onClick={() =>
                              handleEditClick(index, donation.id)
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="w-5 h-5"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                              />
                            </svg>
                          </button>

                          <button
                            className="flex justify-center text-gray-600 hover:text-gray-800"
                            onClick={() => {
                              const newDonations = [...donations];
                              newDonations.splice(index, 1);
                              setDonations(newDonations);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M16.5 9.75v7.5a2.25 2.25 0 01-2.25 2.25h-4.5a2.25 2.25 0 01-2.25-2.25v-7.5m6.75-3.75v-.75a2.25 2.25 0 00-2.25-2.25h-3a2.25 2.25 0 00-2.25 2.25v.75m-3 0h12m-10.5 0h9"
                              />
                            </svg>
                          </button>
                        </div>
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {donation.purpose || "Not Specified"}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {donation.type || "Not Specified"}
                      </td>
                      {matchedFeeDetails.map((feeDetail, index) => (
                        <td
                          key={index}
                          className="border border-gray-300 px-4 py-2 text-center"
                        >
                          {feeDetail.course} - {feeDetail.courseType} -{" "}
                          {feeDetail.userName}
                        </td>
                      ))}
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {donation.amount}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {donation.onBehalfof === "Self"
                          ? "Self"
                          : donation.onBehalfofName || "Other"}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    {matchedFeeDetails.length > 0 ? (
                      <td
                        className="border border-gray-300 px-4 py-2 text-center"
                        colSpan={4}
                      >
                        Total
                      </td>
                    ) : (
                      <td
                        className="border border-gray-300 px-4 py-2 text-center"
                        colSpan={3}
                      >
                        Total
                      </td>
                    )}
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      {totalAmount}
                    </td>
                    <td
                      className="border border-gray-300 px-4 py-2"
                      colSpan={4}
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
        {donations.length > 0 && (
          <div className="flex space-x-4 mt-4">
            <button
              onClick={() => handleDonationButton("close")}
              className=" flex items-center justify-center px-4 py-2 text-sm tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
            >
              Save and Close
            </button>
            <button
              onClick={() => handleDonationButton("new")}
              className=" flex items-center justify-center px-4 py-2 text-sm tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
            >
              Save and New
            </button>
            <button
              onClick={() => setAdd(false)}
              className="flex items-center justify-center px-4 py-2 text-sm tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
      <SideModal isOpen={isModalOpen} onClose={() => {
        setIsModalOpen(false);
      }}>
        <UserForm url={url} userId={''} onClose={() => {
          setIsModalOpen(false);
        }} onSaved={handleUserSaved} />
      </SideModal>
      {/* </div> */}
    </div>
  );
};
